export default function Promo() {
    return (
        // <!-- promo -->
        <div className="promo contact">
            <div className="max-container"></div>
        </div>
    );
}
